import { getCookieByKey } from '~/utils/cookie';

// Personalize 테스트를 위한 환경 셋팅
export const useUserUUID = (): Record<string, string> => {
  const userUUIDCookie = getCookieByKey('x-user-uuid');

  return userUUIDCookie ? { 'x-user-uuid': userUUIDCookie } : {};
};
